var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbarHome',{attrs:{"isInverted":true}}),_c('corosel'),_c('fas'),_c('karyaa'),_c('silab'),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }